<template>
    <div class="WImageSelect">
        <Multiselect
            ref="multiSelect"
            v-model="selectedIcon"
            tagPlaceholder=""
            selectLabel=""
            deselectLabel=""
            selectedLabel=""
            :options="options"
            :placeholder="placeholder"
            :searchable="false"
            :closeOnSelect="true"
            :optionHeight="30"
            :loading="loading"
            :disabled="disabled"
        >
            <template #option="singleOption">
                <WIcon
                    :icon="singleOption.option"
                    :size="20"
                />
            </template>

            <template #singleLabel>
                <WIcon
                    :icon="selectedIcon || ''"
                    :size="20"
                />
            </template>
        </Multiselect>
    </div>
</template>

<script>
import VueTypes from 'vue-types'
import Multiselect from 'vue-multiselect'

export default {
    name: 'WIconSelect',
    components: { Multiselect },
    props: {
        options: VueTypes.array.isRequired,
        placeholder: VueTypes.string.def(''),
        value: VueTypes.oneOfType([Object, String, Array, Number, null]).isRequired,
        disabled: VueTypes.bool.def(false),
        loading: VueTypes.bool.def(false),
        debounceWait: VueTypes.number.def(1000),
    },
    computed: {
        selectedIcon: {
            get () {
                return this.options.find(icon => icon === this.value)
            },
            set (value) {
                if (value) this.$emit('input', value)
            },
        },
    },
}
</script>
